<template>
  <div class="food-detail">
    <NavbarItem />
    <div class="container">
      <div class="row mt-5">
        <div class="col">
          <nav aria-label="breadcrumb" style="margin-top:100px;">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/foods">Foods</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Foods Detail
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div v-if="loadError" class="alert alert-warning mt-2" role="alert">
        {{ loadError }}
      </div>
      <div v-else-if="loading" class="mt-3 text-muted">Memuat...</div>
      <div v-else class="row mt-2">
        <div class="col-12">
          <img
            :src="detailImageSrc"
            referrerpolicy="no-referrer"
            class="img-fluid shadow"
            alt=""
            @error="onDetailImageError"
          />
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-7 mt-4">
              <h5>{{ product.nama }}</h5>
            </div>
            <div class="col-5 mt-4">
              <strong style="color:red;">{{ formatRupiah(product.harga) }}</strong>
            </div>
            <div class="col-12">
              <p class="text-muted">{{ product.note }}</p>
            </div>
          </div>
          <hr />
          <h4>
           
          </h4>
          <form class="mt-4" v-on:submit.prevent>
            <!-- <input type="hidden" v-model="pesan.product_id">  -->
            <div class="form-group detail-qty-row">
              <label class="mb-0">Jumlah pesanan</label>
              <div class="qty-control d-flex align-items-center">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-qty"
                  :disabled="(pesan.jumlah_pemesanan || 0) <= 1"
                  @click="decrementQty"
                >
                  −
                </button>
                <span class="qty-value">{{ pesan.jumlah_pemesanan || 0 }}</span>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-qty"
                  @click="incrementQty"
                >
                  +
                </button>
              </div>
            </div>
            <div class="form-group">
              <label>Keterangan</label>
              <input
                type="text"
                placeholder="Ket: pedas,manis,sedang .."
                class="form-control" autocomplete="off"
                v-model="pesan.keterangan"
                />
            </div>
          </form>
          <div class="detail-fixed-spacer"></div>
        </div>
      </div>
    </div>
    <div class="detail-fixed-action">
      <div class="container">
        <button class="btn btn-success btn-block w-100 detail-fixed-btn" @click="pesanan">
          <b-icon-bag></b-icon-bag> Tambah Pesanan
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarItem from "@/components/Navbar.vue";
import { api, apiRoutes, normalizeProductDetailResponse } from "@/utils/api";
import { formatRupiah } from "@/utils/formatRupiah";

export default {
  name: "FoodDetail",
  components: {
    NavbarItem,
  },

  data() {
    return {
      product: {},
      loading: true,
      loadError: null,
      detailImageFallback: false,
      pesan: {
        jumlah_pemesanan: 1,
        keterangan: "",
      },
    };
  },

  computed: {
    detailImageSrc() {
      if (this.detailImageFallback) {
        return require("@/assets/img/eat.svg");
      }
      return this.product?.gambar || require("@/assets/img/eat.svg");
    },
  },

  watch: {
    "$route.params.id"(id) {
      if (id) this.loadProduct();
    },
  },

  async mounted() {
    await this.loadProduct();
  },

  methods: {
    formatRupiah,
    onDetailImageError() {
      if (!this.detailImageFallback) {
        this.detailImageFallback = true;
      }
    },
    setproduct(data) {
      this.product = data;
    },
    incrementQty() {
      const n = Number(this.pesan.jumlah_pemesanan) || 0;
      this.$set(this.pesan, "jumlah_pemesanan", n + 1);
    },
    decrementQty() {
      const n = Number(this.pesan.jumlah_pemesanan) || 0;
      if (n > 1) this.$set(this.pesan, "jumlah_pemesanan", n - 1);
    },
    pesanan() {
      const qty = Number(this.pesan.jumlah_pemesanan) || 0;
      if (qty > 0) {
        const keranjang = JSON.parse(localStorage.getItem("keranjang") || "[]");
        const kera = `local-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
        const item = {
          kera,
          product_id: this.product.id,
          cafeId: this.product.cafeId || this.product.client?.id_client || null,
          gambar: this.product.gambar,
          nama: this.product.nama,
          harga: this.product.harga,
          jumlah_pemesanan: qty,
          note: this.pesan.keterangan || "",
        };
        keranjang.push(item);
        localStorage.setItem("keranjang", JSON.stringify(keranjang));
        this.$router.push({ path: "/keranjang" });
        this.$toast.success("Berhasil di tambahkan", {
          position: "top-right",
          type: "success",
          duration: 3000,
          dismissible: true,
        });
      } else {
        this.$toast.error("Gagal di tambahkan", {
          position: "top-right",
          type: "error",
          duration: 3000,
          dismissible: true,
        });
      }
    },
    async loadProduct() {
      this.loading = true;
      this.loadError = null;
      this.detailImageFallback = false;
      const id = this.$route.params.id;
      if (!id) {
        this.loading = false;
        this.loadError = "Tidak ada ID produk di URL.";
        return;
      }
      if (!process.env.VUE_APP_API_BASE_URL) {
        this.loading = false;
        this.loadError =
          "VUE_APP_API_BASE_URL belum diatur. Atur di .env lalu restart npm run serve.";
        return;
      }
      try {
        const res = await api(apiRoutes.productsDetail(id), { method: "GET" });
        const payload = normalizeProductDetailResponse(res);
        if (!payload || typeof payload !== "object" || Object.keys(payload).length === 0) {
          this.setproduct({});
          this.loadError = "Data produk kosong atau format tidak dikenali.";
          return;
        }
        if (payload.nama == null && payload.id == null) {
          this.setproduct({});
          this.loadError = "Data produk tidak valid.";
          return;
        }
        this.setproduct(payload);
      } catch (error) {
        console.error(error);
        const status = error.response && error.response.status;
        const msg =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          "Gagal memuat produk";
        this.$toast.error("Detail produk: " + (typeof msg === "string" ? msg : "Gagal memuat"), {
          position: "top-right",
          type: "error",
          duration: 5000,
          dismissible: true,
        });
        this.loadError =
          status === 404
            ? "Produk tidak ditemukan."
            : "Gagal memuat data. Periksa jaringan, CORS, atau VUE_APP_API_BASE_URL.";
        this.setproduct({});
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.detail-qty-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.qty-control {
  gap: 0.5rem;
}
.qty-control .btn-qty {
  width: 2.5rem;
  padding: 0.35rem 0;
  font-size: 1.25rem;
  line-height: 1;
}
.qty-value {
  min-width: 2rem;
  text-align: center;
  font-weight: 600;
}

.detail-fixed-action {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 33px;
  z-index: 30;
  background: #fff;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
  padding: 0.75rem 0 calc(0.75rem + env(safe-area-inset-bottom));
}

.detail-fixed-btn {
  min-height: 44px;
}

.detail-fixed-spacer {
  height: 90px;
}
</style>